//* Libraries imports
import { Suspense } from "react";

//* Components imports
import { Content } from "./_components/index";

export default function ResourceQuestionForm() {
  return (
    <div className="row">
      <Suspense>
        <Content />
      </Suspense>
    </div>
  );
}
